<template>
    <div class="flex items-center justify-center flex-col">
        <div v-for="(tab, i) in tabs" :key="i" @click="$emit('selectTab', tab.name)" class="
              h-20
              flex
              items-center
              justify-center
              gap-1
              cursor-pointer
              hover:bg-hvcolor
              w-full
              flex-col
              relative
            " :class="{
                'sf-tab-active': tab.name == tabActive,
            }">
            <i class="text-xl not-italic wayicon" :class="'wayicon-' + tab.icon"></i>
            <div class="sm:text-sm  leading-6 text-xs">
                {{ tab.name }}
            </div>
        </div>
        <div @click="$emit('selectTab', '')" class="
              xs:hidden block
              h-20
              flex
              items-center
              justify-center
              gap-1
              cursor-pointer
              hover:bg-hvcolor
              w-full
              flex-col
              relative
            " :class="{
                'sf-tab-active': !tabActive,
            }">
            <i class="text-xl not-italic wayicon wayicon-website"></i>
            <div class="sm:text-sm  leading-6 text-xs">
                Preview
            </div>
        </div>
       
    </div>
</template>
<script>
import { } from "vue-tabler-icons";
export default {
    props: {
        tabActive: {
            type: String,
            default: "QR Code",
        },
        contentQr: {
            type: Boolean,
            default: false,
        },
    },
    components: {},
    data() {
        return {
            tabs: [
                {
                    name: "Public Style",
                    icon: "yangshimuban",
                },
                {
                    name: "LOGO",
                    icon: "logo",
                },
                {
                    name: "QR Code",
                    icon: "qr",
                },
                {
                    name: "Edit Style",
                    icon: "palette",
                },
            ],
        };
    },
};
</script>
<style lang="scss">
.sf-tab-active {
    position: relative;
    color: var(--success);

    &:after {
        content: "";
        width: 2px;
        height: 0;
        position: absolute;
        top: 0;
        right: 0;
        background-color: var(--success);
        transition: ease-in-out;
        transition-duration: 150;
        animation: autoHeight 0.4s forwards;
    }
}

@keyframes autoHeight {
    from {
        height: 0;
    }
    to {
        height: 100%;
    }
}
</style>